import { Link } from "react-router-dom";
import { latestUpdates } from "@/mocks/comics";
import RankingSidebar from "@/pages/home/components/RankingSidebar";

export default function LatestUpdate() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950" style={{ fontFamily: "var(--font-heading)" }}>
              最近更新
            </h2>
            <p className="text-sm text-foreground-600 mt-1">新鲜出炉的韩漫章节，不要错过</p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row gap-6">
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {latestUpdates.map((comic) => (
              <Link
                key={comic.id}
                to={`/article/${comic.slug}`}
                className="flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:shadow-sm transition-all duration-300 cursor-pointer group"
              >
                <div className="w-20 h-28 flex-shrink-0 overflow-hidden rounded-md">
                  <img
                    src={comic.cover}
                    alt={comic.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                      {comic.title}
                    </h3>
                    <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                  </div>
                  <div>
                    <p className="text-xs text-primary-600 font-medium line-clamp-1">{comic.latestChapter}</p>
                    <div className="flex items-center gap-3 mt-1.5">
                      <span className="flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-star-fill text-yellow-500 text-[10px]"></i>
                        {comic.rating}
                      </span>
                      <span className="text-xs text-foreground-400">{comic.updatedAt}</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="w-full lg:w-72 flex-shrink-0">
            <RankingSidebar />
          </div>
        </div>
      </div>
    </section>
  );
}